import {
  LayoutDashboard,
  Package,
  Settings,
} from 'lucide-react';

/**
 * Configuration centralisée des liens de navigation pour la sidebar client
 * Utilisée par toutes les pages client pour garantir la cohérence
 * 
 * Note: Les routes /client/requests, /client/offers, /client/tracking, 
 * /client/payments, et /client/history redirigent toutes vers /client/operations
 * avec des onglets différents (voir App.jsx)
 */
export const getClientSidebarLinks = () => [
  {
    to: '/client/dashboard',
    label: 'Tableau de bord',
    icon: LayoutDashboard,
  },
  {
    to: '/client/operations',
    label: 'Mes opérations',
    icon: Package,
  },
  {
    to: '/client/settings',
    label: 'Paramètres',
    icon: Settings,
  },
];

export default getClientSidebarLinks;

